import React from 'react'
import styled from 'styled-components'
import { ReactComponent as KnifeIcon } from '@sketch/icons/knife-21'
import maskURL from '@sketch/icons/knife-mask-21.svg'

const MASKED_LAYER_OFFSET = '14px'
const UN_MASKED_LAYER_OFFSET_X = '-3px'
const UN_MASKED_LAYER_OFFSET_Y = '-1px'

const KnifeIconStyled = styled(KnifeIcon)<{ $isLayerMasked?: boolean }>`
  position: absolute;
  width: 21px;
  height: 21px;
  left: ${({ $isLayerMasked }) => ($isLayerMasked ? MASKED_LAYER_OFFSET : '0')};
`

interface MaskProps {
  maskColor?: string
  $isLayerMasked?: boolean
}

const Mask = styled.div.attrs({ 'data-exportable-icon': true })<MaskProps>`
  position: absolute;
  width: 21px;
  height: 21px;
  left: ${({ $isLayerMasked }) =>
    $isLayerMasked ? MASKED_LAYER_OFFSET : UN_MASKED_LAYER_OFFSET_X};
  bottom: ${({ $isLayerMasked }) =>
    $isLayerMasked ? 'auto' : UN_MASKED_LAYER_OFFSET_Y};

  mask: url(${maskURL});
  background: ${({ maskColor }) => maskColor || 'white'};
`

interface ExportableIconProps {
  maskColor?: string
  className?: string
  isLayerMasked?: boolean
}

const BaseExportableIcon = ({
  maskColor,
  className,
  isLayerMasked,
}: ExportableIconProps) => (
  <>
    {/* A mask is needed for some icons, to fake a border around the exportable
     icon (the small knife icon that appears in the bottom right corner) */}
    <Mask maskColor={maskColor} $isLayerMasked={isLayerMasked} />
    <KnifeIconStyled className={className} $isLayerMasked={isLayerMasked} />
  </>
)

export const ExportableIcon = styled(BaseExportableIcon)`
  position: absolute;

  display: flex;
  justify-content: center;
  align-items: center;

  width: 21px;
  height: 21px;
  flex-shrink: 0;
`
